import React, { Fragment, useCallback, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import Icon from "@fortawesome/react-fontawesome";
import { connect, useSelector } from "react-redux";
import { Alert } from "reactstrap";
import { actions } from "../modules/market";
import Loading from "../components/Loading";
import _ from "lodash/fp";
import ProductTile from "../components/ProductTile";
import useFetchProducts from "../components/useFetchProducts";
import { getCurrentDealer } from "../modules/dealers";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Button from "../components/CustomButton";
import { getUser } from "../modules/auth";
import ProductPaginator from "../components/ProductPaginator";
import SearchProductFilterForm from "../components/ProductFilterForm";
import { toast } from "react-toastify";

const ProductList = _.pipe(
  withRouter,
  connect(
    state => ({ dealer: getCurrentDealer(state) }),
    {
      setCurrentProduct: actions.setCurrentProduct,
      resetState: actions.resetState
    }
  )
)(
  ({
    dealer,
    match: {
      params: { dealer_id }
    },
    history: { push },
    setCurrentProduct,
    resetState
  }) => {
    const dealerId = dealer_id || _.getOr(null, "slug", dealer);
    const { loading, failure, success, products } = useFetchProducts({
      dealerId,
      query: ""
    });
    useEffect(() => {
      return () => {
        resetState([]);
      };
    }, [resetState]);
    // traigo el role desde el estado con el hook de redux
    const role = useSelector(state => state.settings.role);
    // console.log(role)
    // const onClickProduct = useCallback(
    //   product => () => {
    //     setCurrentProduct(product);
    //     const url = dealer_id
    //       ? `/dealers/${dealer_id}/products/${product.slug}`
    //       : `/products/${product.slug}`;
    //     push(url);
    //   },
    //   [dealer_id, push, setCurrentProduct]
    // );
    //marcos
    // const onClickEditProduct = useCallback(
    //   product => () => {
    //     setCurrentProduct(product)
    //     const url = `/products/edit/${product.slug}`
    //     push(url)
    //   }, [push, setCurrentProduct])
    const onClickDeleteProduct = useCallback(
      product => () => {
        setCurrentProduct(product);
        const url = `/products/delete/${product.slug}`;
        push(url);
      },
      [push, setCurrentProduct]
    );
    //marcos
    if (loading) {
      return <Loading label="Fetching products" />;
    }
    if (failure) {
      return <Alert color="danger">{failure}</Alert>;
    }
    if (success) {
      if (_.isEmpty(products)) {
        return <h4>No found proudcts</h4>;
      }
      return (
        <div className="row">
          {_.map(
            product => (
              <div className="col-md-4 selectable">
                <div key={product.id}>
                  <Link to={`/products/${product.slug}`}>
                    <ProductTile product={product} />
                  </Link>
                  {/* si el role es staff le dejo ver EDIT y DELETE, sino, nada */}
                  {role === "staff" ? (
                    <div className="row">
                      <div className="col">
                        <Link
                          className="btn btn-default"
                          to={`/products/${product.id}/edit`}
                          onClick={() => setCurrentProduct(product)}
                        >
                          Edit
                        </Link>
                      </div>
                      <div className="col">
                        <Link
                          className="btn btn-danger"
                          to="#"
                          onClick={onClickDeleteProduct(product)}
                        >
                          Delete
                        </Link>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div />
              </div>
            ),
            products
          )}
        </div>
      );
    }
    return null;
  }
);

ProductList.displayName = "ProductList";

const Products = connect(state => ({
  role: state.settings.role,
  dealer: getCurrentDealer(state),
  user: getUser(state)
}))(({ role, dealer, user }) => {
  const onClickResetCurrentProduct = () => {
    // setCurrentProduct([])
  };
  return (
    <Fragment>
      <div className="row justify-content-between mb-3">
        <div className="col-auto">
          <h4>
            <b>Products</b>
          </h4>
        </div>
        {role === "staff" && (
          <div className="col-auto">
            <div className="row">
              {user && dealer && (
                <div className="col-auto">
                  <CopyToClipboard
                    onCopy={() => {
                      toast.success("URL copied!");
                    }}
                    text={`${window.location.host}/dealers/${
                      dealer.slug
                    }/products`}
                  >
                    <Button simple color="info">
                      Copy Store URL <Icon icon="copy" />
                    </Button>
                  </CopyToClipboard>
                </div>
              )}
              <div className="col-auto">
                <Link
                  to="/products/new"
                  className="btn btn-primary btn-fill"
                  onClick={onClickResetCurrentProduct()}
                >
                  Create Product <Icon icon="plus" />
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col">
          <SearchProductFilterForm />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <ProductList />
        </div>
      </div>
      <div className="row">
        <div className="col mx-4 mx-sm-3">
          <ProductPaginator totalPages={10} />
        </div>
      </div>
    </Fragment>
  );
});

export default Products;
